import { Avatar, Stack, Typography } from '@mui/material';
import { NoDataFoundImage2 } from 'Images';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useIsDesktop } from 'Hooks';
import { LinkAllUpdates } from '../LinkAllUpdates';

export const NoData = () => {
  const isDesktop = useIsDesktop();
  const dictionary = Dictionary[DICTIONARY.Home].userUpdates;
  return (
    <Stack sx={{ justifyContent: 'center', alignItems: 'center' }}>
      <Typography variant='body1' mb={1} pt={2}>
        {dictionary.noDataTitle}
      </Typography>
      <Typography variant='body3' mb={isDesktop ? 5 : 2.5}>
        {dictionary.noDataSubtitle}
      </Typography>
      <Avatar
        sx={{
          width: isDesktop ? '300px' : '180px',
          height: isDesktop ? '250px' : '150px',
          mb: 2,
        }}
        src={NoDataFoundImage2}
        alt={''}
      />
      <LinkAllUpdates />
    </Stack>
  );
};
